<template>
    <div class="query">
        <!--        <div class="title">-->
        <!--            <p class="return" @click="back">-->
        <!--                <img src="~@public/img/user/login/jian.png"/>-->
        <!--            </p>-->
        <!--            中国驻外使领事联系方式查询-->
        <!--        </div>-->
        <van-field required readonly clickable :value="continent" label="所在洲:" placeholder="请选择所在洲"
                   @click="showPickerContinent = true"/>
        <van-popup v-model="showPickerContinent" position="bottom">
            <van-picker show-toolbar :columns="continentList" @cancel="showPickerContinent = false"
                        value-key="title" @confirm="onConfirmContinent"/>
        </van-popup>
        <van-field required readonly clickable :value="region" label="所在国家:" placeholder="请选择所在地区"
                   @click="showPickerRegion = true"/>
        <van-popup v-model="showPickerRegion" position="bottom">
            <van-picker show-toolbar :columns="regionList" @cancel="showPickerRegion = false"
                        value-key="title" @confirm="onConfirmRegion"/>
        </van-popup>
        <van-cell-group>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-if="listShow" v-for="item in dataList">
            <div class="boxList-item">
                <span>所在洲:</span>
                <span>{{item.continents}}</span>
            </div>
            <div class="boxList-item">
                <span>所在国家:</span>
                <span>{{item.codeName}}</span>
            </div>
            <div class="boxList-item">
                <span>大使:</span>
                <span>{{item.personName}}</span>
            </div>
            <div class="boxList-item">
                <span>电话:</span>
                <span>{{item.phone}}</span>
            </div>
            <div class="boxList-item">
                <span>传真:</span>
                <span>{{item.fax}}</span>
            </div>
            <div class="boxList-item">
                <span>邮箱:</span>
                <span>{{item.email}}</span>
            </div>
            <div class="boxList-item">
                <span>地址:</span>
                <span>{{item.address}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {CellGroup, Field, Toast, Button, List, Popup, Picker} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {baseApiMap} from "@/api/base/index";
    import {queryApiMap} from "@/api/query/index";
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "ContactQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [List.name]: List,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        data() {
            return {
                show: false,
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                continent: '',      //选择洲
                showPickerContinent: false,  //是否显示洲选择框
                continentList: [],   //洲集合
                region: '',              //国家或地区
                showPickerRegion: false,         //是否显示国家或地区关系选择框
                regionList: [],              //国家或地区集合
                continentId: '',      //
                regionVal: '',
                listShow: false,
                list: [],
                dataList: [],
            }
        },
        mounted() {
            this.getEmbassyDict();   //加载洲区域
        },
        methods: {
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },
          submit() {
            if (!this.continent) {
              Toast('请选择洲区域')
            } else if (!this.region) {
              Toast('请输入国家或地区')
            } else {
              this.show=true
            }
          },
          async success(val) {
            try {
              const data = {
                code: this.regionVal,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '查询中...'
              })
              const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.embassyQuery}`, data)
              this.show = false
              Toast.clear()
              if (res.data.succ) {
                let data = res.data.data
                if (data.length > 0) {
                  this.listShow = true;
                  this.dataList = Object.assign([], data)
                } else {
                  // this.loading = false
                  Toast.fail('未查询到数据！')
                }
              } else {
                // this.loading = false
                Toast.fail('查询失败！')
              }
            } catch (error) {
              // Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            query() {
                if (!this.continent) {
                    Toast('请选择洲区域')
                } else if (!this.region) {
                    Toast('请输入国家或地区')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    this.queryData()
                }

            },
            async queryData() {
                try {
                    const data = {
                        code: this.regionVal,
                        genGuid: this.receiveVerificationCode.verificationCodeGuid,
                        validCode: this.receiveVerificationCode.verificationCode
                    }
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.embassyQuery}`, data)
                    Toast.clear()
                    //刷新图形验证码
                    this.$refs.childFunction.interactionVerificationCode()
                    if (res.data.succ) {
                        let data = res.data.data
                        if (data.length > 0) {
                            this.listShow = true;
                            this.dataList = Object.assign([], data)
                        } else {
                            // this.loading = false
                            Toast.fail('未查询到数据！')
                        }
                    } else {
                        // this.loading = false
                        Toast.fail('查询失败！')
                    }
                } catch (error) {
                    // Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(error)
                }
            },
            back() {
                this.$router.go(-1);
            },
            /**
             *  获取洲、国家
             */
            getEmbassyDict() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dict.continents`).then(res => {
                    let arr = []
                    if (res.data.succ = true) {
                        arr = res.data.data;
                        this.continentList = arr;
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            //选择洲区域
            onConfirmContinent(value) {
                this.continent = value.title;
                this.continentId = value.id;
                this.getRegion(this.continentId)
                this.showPickerContinent = false;
            },
            //选择国家或地区
            onConfirmRegion(value) {
                this.region = value.title;
                this.regionVal = value.val;
                this.showPickerRegion = false;
            },
            //获取国家或地区
            getRegion() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.pidDict}/${this.continentId}`).then(response => {
                    let arr = [];
                    if (response.data.succ = true) {
                        arr = response.data.data;
                        this.regionList = arr;
                    }

                })
            }
        }

    }
</script>

<style scoped>
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
